"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMetadataStorage = void 0;
const MetadataStorage_1 = require("./metadata/MetadataStorage");
/**
 * Default metadata storage is used as singleton and can be used to storage all metadatas.
 */
exports.defaultMetadataStorage = new MetadataStorage_1.MetadataStorage();
